import { useMemo, useState, type ChangeEvent } from 'react'
import type { AnswerMap, AnswerValue, WorkflowStage } from '../../types/workflow'
interface MedicationAllergiesPickerTemplateProps {
  stage: WorkflowStage
  answers: AnswerMap
  onFieldChange: (fieldId: string, value: AnswerValue) => void
}

export default function MedicationAllergiesPickerTemplate({
  stage,
  answers,
  onFieldChange,
}: MedicationAllergiesPickerTemplateProps) {
  const answerField = stage.answerMapping?.field || 'medication_allergies'

  const initialValue = useMemo(() => {
    const raw = answers?.[answerField]
    return typeof raw === 'string' ? raw : ''
  }, [answers, answerField])

  const [text, setText] = useState<string>(initialValue)

  const handleSave = () => {
    onFieldChange(answerField, text)
  }

  return (
    <div className="flex-1 flex flex-col gap-3">
      <textarea
        className="w-full min-h-[100px] resize-none rounded-xl border border-[var(--ww-border)] bg-[var(--ww-surface)] px-4 py-3.5 font-sans text-[15px] text-[var(--ww-text)] outline-none transition-all duration-200 placeholder:text-[var(--ww-text-3)] focus:border-[var(--ww-accent)] focus:shadow-[0_0_0_3px_var(--ww-glow)]"
        placeholder="List any medication allergies, or type 'None'"
        value={text}
        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setText(e.target.value)}
        autoFocus
      />

      <button
        className="self-start cursor-pointer border-none bg-transparent text-[13px] text-[var(--ww-accent)] hover:underline"
        onClick={() => setText('No known allergies')}
      >
        No known allergies
      </button>

      <div className="mt-auto pt-4 pb-2 -ml-[42px] w-[calc(100%+42px)]">
        <button
          onClick={handleSave}
          disabled={!text.trim()}
          className="w-full py-4 px-6 text-[15px] font-semibold text-[var(--ww-btn-text)] bg-[var(--ww-btn-bg)] border-none rounded-full cursor-pointer transition-all duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.1)] hover:not-disabled:bg-[var(--ww-btn-hover)] hover:not-disabled:-translate-y-0.5 disabled:opacity-25 disabled:cursor-default"
        >
          Continue
        </button>
      </div>
    </div>
  )
}
